import { useWorkingPlatform } from '@repo/platform';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, List } from '@repo/ui';
import { useAppSignInContext } from '@repo/user-session';
import { useRouter } from 'next/router';
import { MouseEventHandler } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import { mySectionUserQuery } from '@/__generated__/mySectionUserQuery.graphql';
import s from '@/components/menu/menu.module.scss';
import { myUserQuery } from '@/graphql/query/my/my-section';
import { AUTH_PATHS, MY_PAGE_PATHS } from '@/lib/constants/paths';

export type MyUserQueryType = PreloadedQuery<mySectionUserQuery, Record<string, unknown>>;

export const MySection = ({ queryRef }: { queryRef: MyUserQueryType }) => {
  const { bznavRefund } = usePreloadedQuery<mySectionUserQuery>(myUserQuery, queryRef);
  const { workingPlatform } = useWorkingPlatform();

  const user = {
    name: bznavRefund.user.name || '고객',
    email: (workingPlatform !== 'toss' && bznavRefund.user.email) || ''
  };

  return (
    <div className={s.my_section_list}>
      <List title={user.name} description={user.email} primaryAction={false} secondaryAction={<MyInfoButton />} />

      <hr className={s.my_section_divider} />
    </div>
  );
};

export function MySectionFallbackComponent() {
  return (
    <div className={s.menu_list_padding}>
      <List title={''} description={''} />
      <hr className={s.my_section_divider} />
    </div>
  );
}

function MyInfoButton() {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();
  const { signRequiredStep } = useAppSignInContext();

  const goMyInfo: MouseEventHandler<HTMLButtonElement> = (e) => {
    /**
     * FIXME
     * type='button' 속성을 사용하면 구UI로 인해 버튼 스타일이 비정상적으로 노출되어
     * type 속성 제거 후(자동으로 submit 타입 설정) 오동작 방지를 위한 preventDefault 처리
     */
    e.preventDefault();

    sendClickEvent('more_body_my-info');

    const nextPage = signRequiredStep.ciAuthentication
      ? `${AUTH_PATHS.CI수집요청}?return_url=${encodeURIComponent(MY_PAGE_PATHS.내정보)}`
      : MY_PAGE_PATHS.내정보;

    router.push(nextPage);
  };

  return (
    <BoxButton variant={'tonal-secondary'} size={'small'} onClick={goMyInfo}>
      내 정보
    </BoxButton>
  );
}
